const featuresPriority = {
  'features-priority-form-date-label': 'Дата',
  'features-priority-filter-title': 'Выберите рекомендации по дате',
  'features-priority-title': 'Установите необходимый порядок рекомендаций',
};

export default featuresPriority;
